/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum OverviewTaskKind {
    Task = '0',
    Location = 1,
    General = 2,
}
